<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!organization">
      <span class="loader"></span>
    </span>
    <div v-if="organization" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="global"
      >
        <tab-pane title="global" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <organization-view-global
            :organization="organization"
            @onGenerateToken="generateToken"
          />
        </tab-pane>

<!--         <tab-pane title="wallet" id="2">
          <span slot="title">
            <wallet-icon class="float-left mr-2" width="15px" />
            {{ $t("COMMON.WALLET") }}
          </span>
          <ElixioWalletComponent
            holder-type="Organization"
            :holder-id="organization.id"
            :force-withdraw="true"
          />
        </tab-pane> -->

        <tab-pane
          title="authorizations"
          id="3"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_PERMISSIONS)"
        >
          <span slot="title">
            <i class="ni ni-key-25"></i>
            {{ $t("ORGANIZATIONS.AUTHORIZATIONS") }}
          </span>
          <organization-view-authorizations :organization="organization" />
        </tab-pane>

        <tab-pane
          title="subscriptions"
          id="4"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_SUBSCRIPTIONS)"
        >
          <span slot="title">
            <i class="fa fa-id-card"></i>
            {{ $t("COMMON.SUBSCRIPTIONS") }}
          </span>
          <organization-view-subscriptions :organization="organization" />
        </tab-pane>

        <tab-pane
          title="users"
          id="5"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_USERS)"
        >
          <span slot="title">
            <i class="ni ni-single-02"></i>
            {{ $t("COMMON.USERS") }}
          </span>
          <organization-view-users :organization="organization" />
        </tab-pane>

        <tab-pane
          title="roles"
          id="6"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_ROLES)"
        >
          <span slot="title">
            <i class="ni ni-hat-3"></i>
            {{ $t("COMMON.ROLES") }}
          </span>
          <organization-view-roles :organization="organization" />
        </tab-pane>

        <tab-pane
          title="elexio-sync"
          id="7"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_PERMISSIONS)"
        >
          <span slot="title">
            {{ $t("ORGANIZATIONS.VIEW_ELIXIO_SYNC") }}
          </span>
          <elixio-connect :organization="organization" />
        </tab-pane>

        <tab-pane
          title="elexio-shipping"
          id="8"
          v-if="
            organization.activeServices?.length > 0 &&
            organization.activeServices.includes(serviceTypeNovoxpress)
          "
        >
          <span slot="title">
            {{ $t("ORGANIZATIONS.VIEW_ELIXIO_SHIPPING") }}
          </span>
          <div class="elite-tabs-wrapper-content p-3">
            <shipment-manager
              shippable-type="Organization"
              :shippable-id="organization.id"
            />
          </div>
        </tab-pane>

        <tab-pane
          title="elexio-signature-templates"
          id="9"
          v-if="
            organization.activeServices?.length > 0 &&
            organization.activeServices.includes(serviceTypeEsign)
          "
        >
          <span slot="title">
            {{ $t("ORGANIZATIONS.VIEW_ELIXIO_SIGNATURE_TEMPLATES") }}
          </span>
          <div class="elite-tabs-wrapper-content p-3">
            <elixio-connect-signature-templates-list-page
              holder-type="Organization"
              :holder-id="organization.id"
            />
          </div>
        </tab-pane>

        <tab-pane
          title="mail-templates"
          id="10"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_TEMPLATES_MAILS)"
        >
          <span slot="title">
            <i class="fal fa-envelope-open-text"></i>
            {{ $t("MAIL_V2.MAIL_TEMPLATES") }}
          </span>
          <organization-mail-templates
            :organization-id="organization.id"
            :organization="organization"
          />
        </tab-pane>

        <tab-pane
          title="files"
          id="998"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_FILES)"
        >
          <span slot="title">
            <i class="ni ni-folder-17"></i>
            {{ $t("COMMON.FILES") }}
          </span>
          <div class="elite-tabs-wrapper-content">
            <list-file-component :object="getFilesObject()" />
          </div>
        </tab-pane>

        <tab-pane
          title="logs"
          id="999"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <organization-view-logs :organization="organization" />
        </tab-pane>
      </tabs>
    </div>

    <modal
      :show.sync="showSubscriptionAddModal"
      modal-classes="modal-secondary"
      size="lg"
    >
      <div class="col-12 text-center mb-2 mt-5">
        <h2>{{ $t("ORGANIZATIONS.SELECT_A_PACKAGE") }}</h2>
      </div>

      <form class="" @submit.prevent="generateSubscriptionInvoice">
        <base-input :label="$t('COMMON.PACKAGES')">
          <package-selector
            @packageChanged="
              (packageId) => (addSubscriptionPackageId = packageId)
            "
          />
        </base-input>
        <validation-error :errors="apiValidationErrors.package" />

        <div class="submit-wrapper">
          <base-button
            type="button"
            class="btn btn-sm elite-submit"
            native-type="submit"
            :disabled="loading"
          >
            <i class="fas fa-spinner fa-spin" v-if="loading"></i>
            {{ $t("ORGANIZATIONS.ADD_SUBSCRIPTION") }}
          </base-button>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { Tabs, TabPane } from "@/components";
import formMixin from "@/mixins/form-mixin";
import requestErrorMixin from "@/mixins/request-error-mixin";
import PackageSelector from "@/components/PackageSelector.vue";
import ValidationError from "@/components/ValidationError.vue";
import ListFileComponent from "@/components/File/ListFileComponent.vue";
import OrganizationViewGlobal from "../partials/OrganizationViewGlobal.vue";
import OrganizationViewUsers from "../partials/OrganizationViewUsers.vue";
import OrganizationViewRoles from "../partials/OrganizationViewRoles.vue";
import OrganizationViewLogs from "../partials/OrganizationViewLogs.vue";
import OrganizationViewSubscriptions from "../partials/OrganizationViewSubscriptions.vue";
import OrganizationViewAuthorizations from "../partials/OrganizationViewAuthorizations.vue";
//import ElixioWalletComponent from "@/components/ElixioWallet/ElixioWalletComponent.vue";
//import WalletIcon from "@/components/ElixioWallet/Icons/WalletIcon.vue";
import ElixioConnect from "@/components/elixio-connect/ModulesListContainer.vue";
import {
  ShipmentManager,
  TemplateList as ElixioConnectSignatureTemplatesListPage,
} from "@latactik/elixio-connect-components-vue2";
import OrganizationMailTemplates from "@/views/Pages/AdminModule/MailV2/components/OrganizationMailTemplates.vue";

const SERVICE_TYPE_CONNECT = "ELIXIOCONNECT";
const SERVICE_TYPE_QUICKBOOKS = "QUICKBOOKS";
const SERVICE_TYPE_NOVOXPRESS = "NOVOXPRESS";
const SERVICE_TYPE_ESIGN = "ESIGN";
const SERVICE_TYPE_PAY = "ELIXIOPAY";
export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    OrganizationViewGlobal,
    OrganizationViewUsers,
    OrganizationViewRoles,
    OrganizationViewLogs,
    OrganizationViewSubscriptions,
    OrganizationViewAuthorizations,
    ListFileComponent,
    PackageSelector,
    ValidationError,
    //ElixioWalletComponent,
    //WalletIcon,
    ElixioConnect,
    ShipmentManager,
    ElixioConnectSignatureTemplatesListPage,
    OrganizationMailTemplates,
  },

  mixins: [formMixin, requestErrorMixin],

  props: {
    organizationId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      organization: null,
      loading: false,
      showSubscriptionAddModal: false,
      addSubscriptionPackageId: null,
      serviceTypeConnect: SERVICE_TYPE_CONNECT,
      serviceTypeQuickbooks: SERVICE_TYPE_QUICKBOOKS,
      serviceTypeNovoxpress: SERVICE_TYPE_NOVOXPRESS,
      serviceTypeEsign: SERVICE_TYPE_ESIGN,
      serviceTypePay: SERVICE_TYPE_PAY,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("organizations/get", this.organizationId);
        this.organization = this.$store.getters["organizations/organization"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async generateSubscriptionInvoice() {
      this.loading = true;
      try {
        const invoice = await this.$store.dispatch(
          "organizations/generateSubscriptionInvoice",
          {
            organizationId: this.organization.id,
            data: { package: this.addSubscriptionPackageId },
          }
        );

        this.$notify({
          type: "success",
          message: this.$t("ORGANIZATIONS.SUBSCRIPTION_INVOICE_ADDED"),
        });
        this.loading = false;

        this.$router.push(this.$objectViewRoute(invoice));
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
        this.setApiValidation(error.response.data.errors);
      }
    },

    getFilesObject() {
      return {
        ...cloneDeep(this.organization),
        organization: cloneDeep(this.organization),
      };
    },

    async generateToken() {
      const confirmation = await swal.fire({
        text: this.$t("COMMON.GENERATE_ACCESS_TOKEN_CONFIRMATION"),
        type: "question",
        customClass: {
          popup: "delete-popup",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      if (confirmation.value !== true) {
        return;
      }

      try {
        this.loading = true;

        const resp = await this.$store.dispatch(
          "organizations/generateAccessToken",
          this.organization.id
        );

        swal.fire({
          text: resp.access_token,
          customClass: {
            popup: "delete-popup",
          },
          type: "question",
          buttonsStyling: false,
          confirmButtonText: this.$t("COMMON.OK"),
          confirmButtonClass: "btn btn-primary",
        });

        this.$notify({
          type: "success",
          message: this.$t("COMMON.ACCESS_TOKEN_GENERATED"),
        });

        this.loading = false;
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },
  },
};
</script>
